import React from "react";

function SearchSelectorPagination({page, onPageChange}) {
    if (!page || page.totalPages <= 1) {
        return null;
    }

    const pageNumber = Number(page.currentPage ?? 0);
    const totalPages = Math.max(1, Number(page.totalPages ?? 1));
    const totalElements = Number(page.totalElements ?? 0);
    const isFirst = pageNumber <= 0;
    const isLast = pageNumber >= totalPages - 1;

    return (
        <div className="search-selector-panel-pagination">
            <span className="search-selector-panel-pagination-summary">
                총 <strong>{totalElements.toLocaleString()}</strong>건 ·{" "}
                <strong>{pageNumber + 1}</strong> / {totalPages} 페이지
            </span>
            <div className="search-selector-panel-pagination-actions">
                <button
                    type="button"
                    className="search-selector-panel-page-btn"
                    disabled={isFirst}
                    onClick={() => onPageChange(pageNumber - 1)}
                >
                    이전
                </button>
                <button
                    type="button"
                    className="search-selector-panel-page-btn"
                    disabled={isLast}
                    onClick={() => onPageChange(pageNumber + 1)}
                >
                    다음
                </button>
            </div>
        </div>
    );
}

export default SearchSelectorPagination;
